import React from 'react';
import { connect } from 'react-redux';
import { hardwareProducts } from '../../../../modules/customer/index.js';
import LoadingPanel from '../../../components/LoadingPanel.jsx';

const getStatusClass = (result) => result.status && result.status.id === 1 ? 'green' : 'red';

const SearchResult = ({ serialNumber, loading, loaded, failed, result = {}}) => <div>
    {loading && <LoadingPanel useSmallLoadingPanel={true}>Søker {serialNumber} ..</LoadingPanel>}
    {failed && <div className="result error">Kunne ikke laste inn data</div>}
    {loaded && <div>
        {!result.name && <div className="result error">
            <b>{serialNumber}</b> ikke funnet
        </div>
        }
        {result.name && <div className="result">
            <b>{serialNumber}</b> - utstyr funnet: <br />
            {result.name} - <b className={getStatusClass(result)}>{result.status.name}</b>
        </div>
        }
    </div>} 
</div>


const mapStateToProps = (state, props) => ({
    result: hardwareProducts.selectors.getSearchResult(state, props.serialNumber),
    loading: hardwareProducts.selectors.isSearchLoading(state, props.serialNumber),
    loaded: hardwareProducts.selectors.isSearchLoaded(state, props.serialNumber),
    failed: hardwareProducts.selectors.isSearchFailed(state, props.serialNumber)
});

const mapDispatchToProps = (dispatch, props) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult);